// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"_desktop_scss_v2_legacy_darkmode__darkmode-dir_scss":"4d9a1b25c2621fe4cf4e","_desktop_scss_v2_legacy_components_game-window__game-window-dir_scss":"278a39555255e8fd43b3","scss_v2_legacy_darkmode__darkmode-dir_scss":"87bae84615e3d0cb07f8"}[chunkId] + ".css";
};